import DOMPurify from 'dompurify'
import { SAFE_ATTRS, SAFE_URI } from '@simplifi/email-html'

export function sanitizeHtml(html: string | null | undefined) {
  if (!html) return ''

  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: [...SAFE_ATTRS],
    ALLOWED_URI_REGEXP: SAFE_URI,
  })
}
